<div class="container p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-bold mb-4">Estoque de produtos</h1>

    <div class="w-1/4">
      <label for="produto" class="block text-xs font-medium text-gray-700">Produto</label>
      <p-dropdown
        [options]="produtos"
        [(ngModel)]="produto"
        name="produto"
        optionLabel="nome"
        placeholder="Selecione o produto"
        [showClear]="true"
        [filter]="true"
        class="w-full"
        [required]="true"
      ></p-dropdown>
    </div>


    <div class="w-1/4">
      <div class="flex flex-col">
        <label for="quantidade" class="mb-1 font-medium text-gray-700">
          Quantidade
        </label>

        <p-inputNumber
          id="quantidade"
          name="quantidade"
          placeholder="Digite a quantidade"
          class="w-full"
          [(ngModel)]="quantidade">
        </p-inputNumber>
      </div>
    </div>

    <div class="flex space-x-4 pt-4">
      <button
        type="button"
        class="bg-blue-500 text-white font-semibold py-2 px-4 rounded shadow hover:bg-blue-600"
        (click)="adicionar(quantidade)">
        Adicionar
      </button>

      <button
        type="button"
        class="bg-red-500 text-white font-semibold py-2 px-4 rounded shadow hover:bg-red-600"
        (click)="remover(quantidade)">
        Remover
      </button>
    </div>

</div>
